import o from"@emotion/styled";
// @ts-ignore
// prettier-ignore
var e="undefined"!=typeof window?o:null==o?void 0:o.default;export{e as styled};
